<template>
  <div class="d-flex justify-content-center">
    <div class="datasource-wrap">
      <div class="card-content card-datasource">
        <div class="title-with-add">
          <p class="card-title">Data Source</p>
          <p class="btn-add">
            <i class="fa fa-plus" /> Add
          </p>
        </div>

        <!-- List Data Source -->
        <div class="list-datasource">
          <div
            v-for="(data, index) in dummyData"
            :key="`${data.title}-${index}`"
            class="datasource"
          >
            <div class="d-flex align-items-center">
              <img src="@/assets/icon-sidebar/data-manager.svg">
              <div class="wrap-title-datasource">
                <p class="datasource-name ellipsis">{{ data.title }}</p>
                <p class="datasource-date">{{ data.timestamp }}</p>
              </div>
            </div>
            <i
              :id="`popover-datasource-${index}`"
              class="fa fa-ellipsis-v toggle-popover"
            />

            <div class="total-table">
              {{ data.total_table }}
              <span>tables</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dummyData: [
        {
          title: 'expense_transaction',
          timestamp: 'Last edit at 22-01-2022, 19:00:00',
          total_table: '12',
        },
        {
          title: 'expense_transaction',
          timestamp: 'Last edit at 22-01-2022, 19:00:00',
          total_table: '12',
        },
        {
          title: 'expense_trail',
          timestamp: 'Last edit at 22-01-2022, 19:00:00',
          total_table: '6',
        },
        {
          title: 'expense_trail',
          timestamp: 'Last edit at 22-01-2022, 19:00:00',
          total_table: '6',
        },
        {
          title: 'expense_trail',
          timestamp: 'Last edit at 22-01-2022, 19:00:00',
          total_table: '6',
        },
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/application-manager/detail/app-tabs/jDataSourceTab.vue